/**
 * Reports — placeholder surface for the council "Explore › Reports" nav.
 *
 * The mockup (renderSidebar §7738) lists Reports as a first-class nav
 * entry but no Reports page has shipped yet. This is a coming-soon
 * placeholder so the link doesn't 404. Real content will replace this
 * surface when the analytics scope is decided.
 */

import { makeStyles, tokens, Title2, Text } from '@fluentui/react-components'
import { DataBarVertical24Regular } from '@fluentui/react-icons'
import { bayerColors } from '../theme'

const useStyles = makeStyles({
  root: {
    maxWidth: '720px',
    margin: '0 auto',
    padding: `${tokens.spacingVerticalXXXL} ${tokens.spacingHorizontalL}`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: tokens.spacingVerticalM,
  },
  iconWrap: {
    width: '56px',
    height: '56px',
    borderRadius: '50%',
    background: bayerColors.navyLight,
    color: bayerColors.navy,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: tokens.spacingVerticalS,
  },
  body: {
    color: tokens.colorNeutralForeground3,
  },
})

export function Reports() {
  const styles = useStyles()
  return (
    <section className={styles.root}>
      <div className={styles.iconWrap} aria-hidden>
        <DataBarVertical24Regular />
      </div>
      <Title2>Reports — coming soon</Title2>
      <Text className={styles.body}>
        Cross-FA throughput, decision velocity, and staffing health reports will land here.
        Until then, FA-scoped throughput tiles live inside each focus area workspace.
      </Text>
    </section>
  )
}
